import { Box, Heading, IconButton, Text, Flex, List } from '@chakra-ui/react';
import { DeleteIcon } from '@chakra-ui/icons';
import { BasketItem } from './types';

interface Props {
  basketItems?: [BasketItem];
  onDelete: (index: string) => void;
}

const Basket = ({ basketItems, onDelete }: Props) => {
  return (
    <Box>
      <Heading mt={{ base: 10, md: 0 }} mb={5} size="md">
        Your Basket
      </Heading>
      <List id="basket_list">
        {basketItems && Object.keys(basketItems).length ? (
          Object.keys(basketItems).map((key, index) => (
            <Flex
              justifyContent="space-between"
              borderRadius={5}
              key={`basket-item-${index}`}
              m={2}
            >
              <Text
                overflow="hidden"
                maxWidth={{ base: 150, sm: 200 }}
                whiteSpace="nowrap"
                textOverflow="ellipsis"
                fontWeight={600}
                mr={2}
              >
                {basketItems[key].title}
              </Text>
              <Text>
                {`$${basketItems[key].price} (x${basketItems[key].count})`}
              </Text>
              <IconButton
                id={`remove_item_${key}`}
                data-item={key}
                ml={5}
                size="xs"
                colorScheme="red"
                aria-label="delete item"
                onClick={() => onDelete(key)}
                icon={<DeleteIcon />}
              />
            </Flex>
          ))
        ) : (
          <Text fontSize="lg">No items</Text>
        )}
      </List>
    </Box>
  );
};

export default Basket;
